// src/stores/useFilters.js
import { create } from "zustand";

// src/stores/useFilters.js
const initialValues = {
  q: "",
  make: "",
  // model: "",
  model: [],
  minPrice: "",
  maxPrice: "",
  year: "",
  color: "",
  bodyType: [], // ← new
  fuelType: [], // ← new
  transmissionType: [], // ← new
  mileageBucket: "", // ← new
  // page: 1,
  // limit: 18,
  // sortBy: "price",
  // sortOrder: "asc",
};

export const useFilters = create((set) => ({
  values: { ...initialValues },

  // update one field, reset page on any non-page change
  set: (field, value) =>
    set((state) => ({
      values: {
        ...state.values,
        [field]: value,
        // page: field === "page" ? value : 1,
      },
    })),

  // clear all filters
  reset: () => set({ values: { ...initialValues } }),
}));
